const initialState = {};

export default (state=initialState, action) => {
	switch (action.type) {
		case 'SET_STARTED_WITH_OFFERCODE':
            return {...state, startedWithOfferCode: action.startedWithOfferCode};
        case 'SET_OFFERCODE':
            return {...state, offerCode: action.offerCode};
		default: 
			return state			
	}
}


// WEBPACK FOOTER //
// ./src/reducers/offerCodeReducer.js